import { Link } from "react-router-dom";
import CaseImage from "@/components/CaseImage";
import { getCasePhotoUrls } from "@/lib/api";
import { getPublicStatusLabel } from "@/lib/statusLabels";

export default function SuccessStoryCard({ caseItem: c }) {
  const photos = getCasePhotoUrls(c);
  const story = c.sanctuary_story || c.public_story || c.case_history;
  const hasPhotos = photos.length > 0;
  const isBeforeAfter = photos.length > 1;

  return (
    <Link
      to={`/case/${c.slug}`}
      data-testid={`success-story-card-${c.slug}`}
      className="block bg-amtm-surface border border-amtm-border rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:scale-[1.02]"
    >
      <div className={`grid grid-cols-2 overflow-hidden ${hasPhotos ? "h-56" : "h-28"}`}>
        {isBeforeAfter ? (
          <>
            <CaseImage src={photos[0]} alt="before" animalType={c.animal_type} className="w-full h-full object-cover" />
            <CaseImage src={photos[1]} alt="after" animalType={c.animal_type} className="w-full h-full object-cover" />
          </>
        ) : (
          <CaseImage src={photos[0]} alt={c.animal_name} animalType={c.animal_type} className="col-span-2 w-full h-full object-cover" />
        )}
      </div>

      <div className="p-5">
        {isBeforeAfter && (
          <div className="grid grid-cols-2 gap-2 mb-3">
            <span className="text-xs font-semibold bg-amtm-bg text-amtm-textMuted px-2.5 py-1 rounded-full w-fit">Before</span>
            <span className="text-xs font-semibold bg-amtm-success/15 text-amtm-success px-2.5 py-1 rounded-full w-fit">Now</span>
          </div>
        )}
        <h3 className="font-display text-2xl text-amtm-text">{c.animal_name}</h3>
        <p className="text-sm text-amtm-textMuted mt-1 line-clamp-3">{story}</p>
        <span className="inline-block mt-3 text-xs font-semibold bg-amtm-success/15 text-amtm-success px-3 py-1 rounded-full">{getPublicStatusLabel(c.status)}</span>
      </div>
    </Link>
  );
}
